import { getReferralPromotions } from "@faire/retailer-visitor-shared/serialized-data/getReferralPromotions";
import { getSettingR2BAwardConfiguration } from "@faire/retailer-visitor-shared/settings/getSettingR2BAwardConfiguration";
import { moneyOrZero, formatMoney } from "@faire/web--source/common/money";
var formatAward = function(award) {
    return formatMoney({
        money: award,
        omitCentsIfZero: true,
        disableAutoConvertCurrency: true
    });
};
export var useR2BAwardStore = function() {
    var _getReferralPromotions;
    var incentiveActivationAmount = moneyOrZero(getSettingR2BAwardConfiguration().r2b_activation_amount);
    var incentiveActivationAmountFormatted = formatAward(incentiveActivationAmount);
    var incentivePerOrderAmount = moneyOrZero(getSettingR2BAwardConfiguration().r2b_per_order_amount);
    var incentivePerOrderAmountFormatted = formatAward(incentivePerOrderAmount);
    var activePromotions = new Set((_getReferralPromotions = getReferralPromotions()) === null || _getReferralPromotions === void 0 ? void 0 : _getReferralPromotions.map(function(brandReferralPromotion) {
        return brandReferralPromotion.promotion_type;
    }).filter(function(promotionType) {
        return promotionType !== undefined;
    }));
    var r2bAdvertisedRetailerAward = moneyOrZero(getSettingR2BAwardConfiguration().r2b_max_credits);
    var r2bAdvertisedRetailerAwardFormatted = formatAward(r2bAdvertisedRetailerAward);
    var hasActivationAmount = Boolean(incentiveActivationAmount.amount_cents && incentiveActivationAmount.amount_cents > 0);
    return {
        incentiveActivationAmount: incentiveActivationAmount,
        incentiveActivationAmountFormatted: incentiveActivationAmountFormatted,
        incentivePerOrderAmountFormatted: incentivePerOrderAmountFormatted,
        activePromotions: activePromotions,
        r2bAdvertisedRetailerAward: r2bAdvertisedRetailerAward,
        r2bAdvertisedRetailerAwardFormatted: r2bAdvertisedRetailerAwardFormatted,
        hasActivationAmount: hasActivationAmount
    };
};
